export default __webpack_public_path__ + "static/media/profile.fdd543ad.jpg";